export type NavigationPermission = string | string[];

const NAVIGATION_PERMISSION_MAP: Record<string, NavigationPermission> = {
  dashboard: "MATERIALMOVEMENT.READ",
  users: "USER.READ",
  "org-positions": "ORG_POSITION.READ",
  roles: "ROLE.READ",
  permissions: "PERMISSION.READ",
  materials: "MATERIAL.READ",
  "material-unit-conversions": "MATERIAL_UNIT_CONVERSION.READ",
  "material-groups": "MATERIALGROUP.READ",
  "plant-types": "PLANTTYPE.READ",
  plants: "PLANT.READ",
  "storage-locations": "STORAGELOC.READ",
  "storage-loc-templates": "STORAGELOCLAYOUTTEMPLATE.READ",
  batches: "BATCH.READ",
  "batch-templates": "BATCHTEMPLATE.READ",
  companies: "COMPANY.READ",
  units: "UNIT.READ",
  "cost-centers": "COSTCENTER.READ",
  "production-orders": "PRODUCTIONORDER.READ",
  "movement-types": "MOVEMENTTYPE.READ",
  vendors: "VENDOR.READ",
  "commercial-business-lines": "COMMERCIALBUSINESSLINE.READ",
  "vendor-services": "VENDORSERVICE.READ",
  customers: "CUSTOMER.READ",
  "payment-terms": "PAYMENTTERM.READ",
  "document-classes": "DOCUMENTCLASS.READ",
  "purchase-orders": "PURCHASEORDER.READ",
  "sales-orders": "SALESORDER.READ",
  "carrier-types": "CARRIERTYPE.READ",
  carriers: "CARRIER.READ",
  drivers: "DRIVER.READ",
  vehicles: "VEHICLE.READ",
  "vehicle-assignments": "VEHICLEASSIGNMENT.READ",
  trips: "TRIP.READ",
  routes: "ROUTE.READ",
  fields: "FIELD.READ",
  employees: "EMPLOYEE.READ",
  cuarteles: "CUARTEL.READ",
  attendance: "ATTENDANCE.READ",
  "labor-tickets": "LABOR_TICKET.READ",
  "labor-activities": "LABOR_ACTIVITY.READ",
  "labor-rates": "LABOR_RATE.READ",
  "labor-rate-generals": "LABOR_RATE_GENERAL.READ",
  especies: "SPECIES.READ",
  variedades: "VARIETY.READ",
  "labor-retention": "LABOR_RETENTION.READ",
  "material-movements": "MATERIALMOVEMENT.READ",
  "dispatch-guides": "MATERIALMOVEMENT.READ",
  "dispatch-guide-statuses": "DISPATCHGUIDESTATUS.READ",
  "dispatch-flow-profiles": "DISPATCHGUIDESTATUS.READ",
  "approval-flows": "APPROVAL_FLOW.READ",
  stock: "MATERIALMOVEMENT.READ",
  "work-orders": "WORKORDER.READ",
  "work-order-templates": "WORKORDERTEMPLATE.READ",
  "work-order-activities": "WORKORDERACTIVITY.READ",
  "industrial-formulas": "INDUSTRIALFORMULA.READ",
  "material-requests": "MATERIALREQUEST.READ",
  subscriptions: "SUBSCRIPTION.READ",
  plans: "PLAN.READ",
  "plan-prices": "PLAN_PRICE.READ",
  invoices: "INVOICE.READ",
  currencies: "CURRENCY.READ",
  "units-core": "UNIT.READ",
  audit: "AUDIT.READ",
};

export function getNavigationPermission(
  moduleId: string,
): NavigationPermission | undefined {
  return NAVIGATION_PERMISSION_MAP[moduleId];
}

type PermissionChecker = (permission: string | string[]) => boolean;

/** Sidebar, welcome y tarjetas de módulo: exige permiso mapeado y permisos ya cargados. */
export function canAccessNavModule(
  moduleId: string,
  hasPermission: PermissionChecker,
  permissionsLoading = false,
): boolean {
  if (permissionsLoading) return false;
  const requiredPermission = getNavigationPermission(moduleId);
  if (!requiredPermission) return false;
  if (Array.isArray(requiredPermission)) {
    return requiredPermission.some((permission) => hasPermission(permission));
  }
  return hasPermission(requiredPermission);
}
